import React, {useState, useGlobal} from 'reactn';
import { ItemStatusNavStyled } from './ItemStatusNav.styled';

const ItemStatusNav = () => {

    const [returnType, setReturnType] = useGlobal("globalReturnType");

    return (
        <ItemStatusNavStyled className='gtm-tab'>
                <button className={returnType === "receiving" ? "active" : ""} onClick={() => setReturnType("receiving")}>Receiving</button>
                <button className={returnType === "sending" ? "active" : ""}  onClick={() => setReturnType("sending")}>Sending</button>
        </ItemStatusNavStyled>
    );
};

export default ItemStatusNav;